import { applySnapshot, types } from "mobx-state-tree";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";

export const TechnicalAssistModel = types
    .model("TechnicalAssistModel", {
        imageUrl: customtypes.optional(types.string, ""),
        title: customtypes.optional(types.string, ""),
        expiryDate: customtypes.optional(types.string, ""),
        detail: customtypes.optional(types.string, ""),
        interstors: customtypes.optional(types.number, 0),
        isInterested: types.optional(types.boolean, false),
    })
    .actions((self: any) => ({
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
        setTechnicalAssist: (technicalAssist: any) => {
            self.image = technicalAssist.imageUrl;
            self.title = technicalAssist.title;
            self.expiryDate = technicalAssist.expiryDate;
            self.detail = technicalAssist.detail;
            self.interstors = technicalAssist.interstors;
        },
        resetAll: () => {
            applySnapshot(self, {});
        },
    }));
export type ITechnicalAssistModel = typeof TechnicalAssistModel.Type;
